import React from 'react';
import PropTypes from 'prop-types';
import { compose } from '../../../services/utilityFunctions';
import translate from '../../../commonComponents/translate';
import withCSRF from '../../../commonComponents/withCSRF';
import Modal from '../../../commonComponents/modal/Modal';
import JourneyProp from '../propTypes/journeyProp';

function EndJourneyModal({ t, onClose, journey }) {
  const hasImage = journey.image && journey.image.url;

  return (
    <Modal onClose={onClose}>
      <div
        className="modal-dialog modal-dialog-centered modal-journey modal-end-journey"
        role="document"
      >
        <div className="modal-content">
          <div className="modal-header">
            <div className="image-modal">
              {hasImage && <img src={journey.image.url} alt="journey" />}
              <div className="stripes-background" />
            </div>
            {onClose && (
              <button
                type="button"
                className="close"
                onClick={onClose}
                style={{ zIndex: 20 }}
              >
                <span aria-hidden="true">×</span>
              </button>
            )}
          </div>
          <div className="modal-body">
            <div className="container-fluid">
              <h3 className="congratulations">
                {t('journey_congratulations')}
              </h3>
              <p style={{ whiteSpace: 'pre-wrap' }}>
                {`${t('journey_finished1')} `}
                <span className="text-dynamic">{journey.title}</span>
                {t('journey_finished2')}
              </p>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-dynamic"
              onClick={() => onClose(false)}
            >
              {t('journey_see_more')}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
}

EndJourneyModal.propTypes = {
  t: PropTypes.func.isRequired,
  journey: PropTypes.shape(JourneyProp.propType).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default compose(
  withCSRF,
  translate,
)(EndJourneyModal);
